module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/14-032c397a610bd5436d3999def5617f2e.jpg";